module.exports = __webpack_public_path__ + "static/img/ex09.e8db15fb.png";